import API from "../helpers/API";
import HereAPI from "../helpers/HereAPINew";

// Definizione delle classi API e HereAPI con i loro tipi
const api = new API();
const hereApi = new HereAPI();

export const API_BASE_URL = `https://api.${api.getURL()}`;
export const AWS_LOCATION_KEY = hereApi.HERE_API_KEY;
export const AWS_LOCATION_PLACE_INDEX = hereApi.PLACE_INDEX;

export const queries = {
  xs: window.matchMedia("(max-width: 575.98px)"),
  sm: window.matchMedia("(min-width: 576px) and (max-width: 767.98px)"),
  md: window.matchMedia("(min-width: 768px) and (max-width: 991.98px)"),
  lg: window.matchMedia("(min-width: 992px) and (max-width: 1199.98px)"),
  xl: window.matchMedia("(min-width: 1200px) and (max-width: 1399.98px)"),
  xxl: window.matchMedia("(min-width: 1400px)"),
};
